export default __webpack_public_path__ + "static/nicole-4244a8a05d6268cc491315df437eb54b.jpg";